module.exports = __webpack_public_path__ + "img/rf_advanced_5.080d3270.jpg";